import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// components
import { Row } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import SearchBar from "../../../components/SearchBar";
import { getGroupBooks, getBooksBy } from '../../../api/books';
import HomeCarousel from '../../../components/HomeCarousel';

const BookGallery = (props) => {

  const { lang, query, setQuery  } =  props;  
  const [loading, setLoading] = useState(true);
  const [loadingBooks, setLoadingBooks] = useState(true);
  
  const [groups, setGroups] = useState([]);
  const [books, setBooks]= useState([]);
  const [tag, setTag]= useState("");
  
  const params = useParams()
  const history = useNavigate()
  const { field, order } = params;

  const fetchBooks = async () => {

    if (query){
      setLoading(true);
      history("/editorial/books")
    }else{
      const {data} = await getGroupBooks(field)
          .then(response=>{
            return response;
          })
          .catch(function (error) {
            return {data:[]};
          })
      
      const value = data[0].value !== "" ? data[0].value: "$empty"  
      const { data:docs } = await getBooksBy(field, value, 5)
      .then(response=>{
        setLoading(false);
        return response;
      })

      setBooks(docs?.docs)
      setGroups(data);
      setTag(value)
    }
  }

  const fetchCollection = async () =>{
    setLoadingBooks(true);
    const value = tag !== "" ? tag: "$empty"  
    const { data:docs } = await getBooksBy(field, value, 5)
    .then(response=>{
      setLoadingBooks(false);
      return response;
    })
    setBooks(docs?.docs)
    return docs?.docs
  }

  useEffect(() => {
      fetchBooks();
  }, [field, order, query])

  useEffect(() => {
    fetchCollection();
  }, [tag])
  
  const titleGroup = ( text)=>{
    if( text.length > 0 ){
      return text.charAt(0).toUpperCase() + text.slice(1)
    }else{
      return "Varios"
    }
  }

  const displayBooks = () => {
    console.log("displayBooks ", books)
    if(loadingBooks){
      return (
        <div style={{ 
          display:"flex", 
          alignItems:'center',
          flexDirection:'row'
        }}>
        {
          [1,2,3,4,5].map((key)=>{
            return (<div key={key} style={{ width:'70%', height: '250px', margin:'10px' }} className='skeleton'></div>)
          })
        }
      </div>)
    }else{
      return (<HomeCarousel
        dataList = {books}
        scrolling= {false}
      />)
    }
  }

  const showAccordion = () => {
    return (
      <>
        <div className="gallery" style={{ display:'flex', flexWrap:'wrap' }}>
          <Accordion defaultActiveKey="active0" style={{ width:'100%' }} flush>
            {
              groups?.map((element, id) => {
                return(
                  <Accordion.Item key={element._id} eventKey={`active${id}`} onClick={()=>{ console.log(element.value); setTag(element.value)}} >
                    <Accordion.Header> {titleGroup(element.value)} </Accordion.Header>
                    <Accordion.Body>
                    Esta colección cuenta con {element.count} obras en el catálogo, 
                    utiliza este enlace para seguir explorando.
                    {displayBooks()}
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })
            }
          </Accordion>
        </div >
      </>
    )
  }

  const showGalleryBooks = () => {

    // If the books are not present yet, display loading feedbaack to user.
    if (loading) {
      return (
        <Row className='justify-content-md-center'>
          <Accordion defaultActiveKey="a0" style={{ width:'100%' }} flush>
            <Accordion.Item  eventKey={`a0`} >
            <Accordion.Header>  Cargando grupos...  </Accordion.Header>
            <Accordion.Body 
              style={{ 
                display:"flex", 
                alignItems:'center',
                flexDirection:'row'
              }}>  
              
              {
                [1,2,3,4,5].map((key)=>{
                  return (<div key={key} style={{ width:'70%', height: '250px', margin:'10px' }} className='skeleton'></div>)
                })
              }
            </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>
      )
    }

    // TODO retornar un componente especial cuando no existan libros para mostrar.
    if (groups && groups.length === 0) {
      return (
        <Row className='justify-content-md-center'>
          <Accordion defaultActiveKey="a0" style={{ width:'100%' }} flush>
            <Accordion.Item  eventKey={`a0`} >
            <Accordion.Header >  No hay libros en esta colección </Accordion.Header>
            <Accordion.Body 
              style={{ 
                display:"flex", 
                alignItems:'center',
                flexDirection:'row'
              }}>
            </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Row>
      )
    }

    return showAccordion();
  }

  return (
    <>
      <SearchBar 
        searchItem={ setQuery }
        query={query}
        setQuery={setQuery}
        placeholder={lang.book.title}
      />
      <Row className=''>
        {showGalleryBooks()}
      </Row>
    </>
  );
};

export default BookGallery;
